import {
  UPDATE_NAVIGATION_COLLAPSED,
  UPDATE_SHOW_INVITE_TEAMMATE_TOOLTIP,
} from '../constants/actions';

export const updateNavigationCollapsed = isCollapsed => {
  return { type: UPDATE_NAVIGATION_COLLAPSED, isCollapsed };
};

export const showInviteTeammatesToolTip = showInviteToolTip => {
  return { type: UPDATE_SHOW_INVITE_TEAMMATE_TOOLTIP, showInviteToolTip };
};
